import { upperFirst } from "lodash-es";
import { getSingular } from "./annotationTypes";
export default function getAnnotationNameAndStartStopString({
  name,
  start,
  end,
  type,
  message,
  annotationTypePlural,
  overlapsSelf,
  isWrappedAddon
}, { startText, isProtein, readOnly } = {}) {
  const typeToUse = (() => {
    if (annotationTypePlural) {
      const singularKey = getSingular(annotationTypePlural);
      if (singularKey === "cutsite") {
        return "Cut site" + (annotationTypePlural === "features" ? ` (${type})` : "");
      }
      if (singularKey === "orf") {
        return "ORF" + (annotationTypePlural === "features" ? ` (${type})` : "");
      }
      return upperFirst(getSingular(annotationTypePlural)) + (annotationTypePlural === "features" ? ` (${type})` : "");
    }
    return "";
  })();
  if (isWrappedAddon) {
    const oldEnd = end;
    end = start - 1;
    start = oldEnd + 1;
  }
  const interactionInstructions = readOnly ? "" : annotationTypePlural === "cutsites" ? `

\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501
  INTERACTIONS:
\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501
   click \u2192 top cut position
   alt/option+click \u2192 bottom cut position
   cmd/ctrl+click \u2192 recognition range
   double click \u2192 show info` : `

\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501
  INTERACTIONS:
\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501
   alt/option+click \u2192 jump row view to start/end
   double click \u2192 edit`;
  return `${startText ? startText : ""} ${typeToUse ? typeToUse + " -" : ""} ${name ? name : ""} - Start: ${isProtein ? (start + 3) / 3 : start + 1} End: ${isProtein ? (end + 1) / 3 : end + 1} ${overlapsSelf ? "(Overlaps Self) " : ""}${message ? "\n" + message : ""}${interactionInstructions}`;
}
